"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const page_filter_item_1 = require("./page-filter-item");
const page_filter_helper_1 = require("../helper/page-filter-helper");
const idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
const filter_item_type_1 = require("./filter-item-type");
const page_filter_item_style_1 = require("./page-filter-item-style");
const lookup_selection_options_1 = require("./lookup-selection-options");
class FilterItemFactory {
    constructor(metaCategories) {
        this.metaCategories = metaCategories;
    }
    create(path) {
        const mustBeConvertedToCategoryFilter = FilterItemFactory.mustBeConvertedToCategoryFilter(path.value);
        const isCategoryPath = path.value.hasOwnProperty('categoryType') || mustBeConvertedToCategoryFilter;
        if (isCategoryPath) {
            const metaCategory = mustBeConvertedToCategoryFilter
                ? this.metaCategories.get(path.value.metadata.get('filterCategory'))
                : this.metaCategories.get(path.value.metaCategoryId.systemName);
            const filterType = mustBeConvertedToCategoryFilter
                ? filter_item_type_1.FilterItemType.CATEGORY_STANDARD
                : page_filter_helper_1.convertToFilterItemType(path.value);
            const searchCategoryFields = metaCategory.getNameMetaFieldIds()
                ? metaCategory.getNameMetaFieldIds().map(metaField => metaField.getSystemName())
                : [];
            if (!metaCategory) {
                throw new Error(`MetaCategory of ${path} is wrong and does not exist in KB or exists with different name`);
            }
            if (metaCategory.getIsWithVersioning()) {
                return new page_filter_item_1.PageFilterItem(path.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(path.value.name), filterType, path.currencyId, metaCategory.getIsWithVersioning(), metaCategory.getSystemName(), null, searchCategoryFields, new page_filter_item_style_1.PageFilterItemStyle(), true, lookup_selection_options_1.LookupSelectionOptions.MULTISELECT, mustBeConvertedToCategoryFilter);
            }
            if (path.name == "Indicator") {
                return new page_filter_item_1.PageFilterItem(path.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(path.value.name), filterType, path.currencyId, false, metaCategory.getSystemName(), null, searchCategoryFields, undefined, metaCategory.getIsCacheable(), lookup_selection_options_1.LookupSelectionOptions.MULTISELECT, mustBeConvertedToCategoryFilter);
            }
            return new page_filter_item_1.PageFilterItem(path.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(path.value.name), filterType, path.currencyId, false, null, null, searchCategoryFields, undefined, metaCategory.getIsCacheable(), lookup_selection_options_1.LookupSelectionOptions.MULTISELECT, mustBeConvertedToCategoryFilter);
        }
        return new page_filter_item_1.PageFilterItem(path.id, new idm_crosscutting_concepts_frontend_1.MultilingualString(path.value.name), page_filter_helper_1.convertToFilterItemType(path.value), path.currencyId, null, null, null);
    }
    static mustBeConvertedToCategoryFilter(path) {
        const convertFilter = path.metadata.get('convertFilter');
        if (convertFilter == 'and') {
            if (path.metadata.get('filterCategory')) {
                return true;
            }
            throw new Error(`Conversion filter category not specified in path ${path.id}`);
        }
        return false;
    }
}
exports.FilterItemFactory = FilterItemFactory;
//# sourceMappingURL=filter-item-factory.js.map